import { useMemo, useCallback } from 'react';
import { useDispatch, useStore } from 'react-redux';
import { change, getFormAsyncErrors, getFormValues, getFormSyncErrors, submit } from 'redux-form';
import { FormAdapterContextProvider } from '../context/FormAdapterContext';
import { FORM_ADAPTER_TYPES } from '../constants';
import { getNestedValue, waitForAsyncValidation } from '../utils';
import { jsx as _jsx } from "react/jsx-runtime";
const ReduxFormAdapterProvider = ({
  formName,
  children
}) => {
  const dispatch = useDispatch();
  const store = useStore();
  const handleSetValue = useCallback((name, value) => {
    dispatch(change(formName, name, value));
  }, [formName, dispatch]);
  const handleGetValues = useCallback(name => {
    var _ref;
    const formValues = (_ref = getFormValues(formName)(store.getState())) !== null && _ref !== void 0 ? _ref : {};
    return name ? getNestedValue(formValues, name) : formValues;
  }, [formName, store]);
  const handleSetValues = useCallback(values => {
    const keys = Object.keys(values);
    keys.forEach(name => {
      dispatch(change(formName, name, values[name]));
    });
  }, [formName, dispatch]);
  const handleTriggerValidation = useCallback(async () => {
    await waitForAsyncValidation(formName, store);
    const state = store.getState();
    const reduxFormErrors = getFormSyncErrors(formName)(state);
    const reduxFormAsyncErrors = getFormAsyncErrors(formName)(state);
    const hasNoSyncErrors = !reduxFormErrors || Object.keys(reduxFormErrors).length === 0;
    const hasNoAsyncErrors = !reduxFormAsyncErrors || Object.keys(reduxFormAsyncErrors).length === 0;
    const isReduxFormValid = hasNoSyncErrors && hasNoAsyncErrors;

    // Dispatching submit when form is invalid
    // Marks all Redux Form fields as touched → errors become visible
    if (!isReduxFormValid) {
      dispatch(submit(formName));
    }
    return isReduxFormValid;
  }, [dispatch, formName, store]);
  const handleSubmitForm = useCallback(() => {
    dispatch(submit(formName));
    return Promise.resolve();
  }, [formName, dispatch]);
  const config = useMemo(() => ({
    formName,
    getValues: handleGetValues,
    setValue: handleSetValue,
    setValues: handleSetValues,
    store,
    submitForm: handleSubmitForm,
    triggerValidation: handleTriggerValidation,
    type: FORM_ADAPTER_TYPES.REDUX
  }), [formName, handleSetValue, handleSetValues, handleGetValues, store, handleTriggerValidation, handleSubmitForm]);
  return /*#__PURE__*/_jsx(FormAdapterContextProvider, {
    value: config,
    children: children
  });
};
export default ReduxFormAdapterProvider;
//# sourceMappingURL=ReduxFormAdapterProvider.js.map